import axios from 'axios';

/**
 * 获取 OSS 文件的临时访问签名地址
 * 接口: /oss/GetSignedUrl?fileName=xxx
 * @param {String} filePath - 文件路径/名称 (IntroductionVideoPath 或 IntroductionPPTPath)
 * @returns {Promise<String>} 返回阿里云带签名的完整 URL
 */
export function getOssSignedUrl(filePath) {
  // 修改点：去掉了参数列表里的 reject
  return new Promise((resolve) => {
    // 1. 空值检查
    if (!filePath || filePath === 'null') {
      resolve('');
      return;
    }

    // 2. 如果已经是完整 HTTP 链接，直接返回，无需签名
    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
      resolve(filePath);
      return;
    }

    // 3. 调用真实后端接口
    // 注意：如果你在本地运行且后端在另一台机器，需要在 vue.config.js 配置 proxy，或者这里写死完整后端域名
    axios.get('/oss/GetSignedUrl', {
      params: {
        fileName: filePath
      }
    })
    .then(response => {
      // 根据你的描述，接口直接返回阿里云地址字符串
      // 如果后端返回的是 JSON 对象 (如 { code: 200, data: 'http...' })，请改为 response.data.data
      const signedUrl = response.data; 
      resolve(signedUrl);
    })
    .catch(error => {
      console.error(`[OSS] 获取签名失败 (${filePath}):`, error);
      // 失败时返回空字符串，保证页面不报错，只是不显示视频
      resolve('');
    });
  });
}

/**
 * 通用下载文件/打开新窗口预览
 * @param {String} url - 文件地址
 * @param {String} filename - 下载文件名
 */
export function downloadFile(url, filename) {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'download';
  link.target = '_blank'; // 新窗口打开，浏览器能识别的格式(PDF/MP4)通常会直接预览而非下载
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}